(() => {
  if (window.beyondGenericFiltersBound) return;
  window.beyondGenericFiltersBound = true;
  const SALE = 'filter.p.m.custom.percent_discount_range';
  const brandSearch = new Map();
  const textOf = input => input.closest('li')?.querySelector('.facet-checkbox__text-label')?.textContent.trim() || input.value;
  const refreshMobileFeedback = () => {
    const form = document.querySelector('#FacetFiltersFormMobile');
    if (!form) return;
    const quick = form.querySelector('[data-beyond-size]');
    let sizes = [];
    try { sizes = JSON.parse(quick?.dataset.clothingSelection || '[]'); } catch {}
    const checked = [...form.querySelectorAll('input[type="checkbox"][name]:checked')];
    const others = checked.filter(input => input.name !== quick?.dataset.sizeParam && input.name !== SALE && input.name !== 'filter.v.availability');
    const prices = [...form.querySelectorAll('price-range input')].some(input => input.value);
    const count = sizes.length + others.length + (form.querySelector('[data-beyond-sale-toggle]')?.checked ? 1 : 0) + (prices ? 1 : 0);
    const open = document.querySelector('.mobile-facets__open');
    if (!open) return;
    let badge = open.querySelector('[data-beyond-filter-count]');
    if (!badge) { badge = document.createElement('span'); badge.dataset.beyondFilterCount=''; badge.className='beyond-mobile-filter-count'; open.append(badge); }
    badge.hidden = count === 0;
    if (badge.textContent !== String(count)) badge.textContent = String(count);
    badge.setAttribute('aria-label', count + ' selections');
  };
  window.beyondRefreshFilters = () => {
    document.querySelectorAll('#FacetFiltersForm,#FacetFiltersFormMobile').forEach(form => {
      const quick = form.querySelector('[data-beyond-size]');
      form.querySelectorAll('details.js-filter').forEach(details => {
        const inputs = [...details.querySelectorAll('input[type="checkbox"][name]')];
        const param = inputs[0]?.name;
        const summary = details.querySelector('summary');
        if (!summary) return;
        if (!details.dataset.beyondInitialized) {
          details.dataset.beyondInitialized = 'true';
          if (form.id === 'FacetFiltersFormMobile') details.removeAttribute('open');
        }
        details.classList.toggle('beyond-hidden-filter', param === SALE || (param === 'filter.v.option.size' && !!quick));
        if (param === 'filter.p.vendor') details.classList.toggle('beyond-hidden-filter', inputs.length <= 1 && !inputs.some(i=>i.checked));
        if (param === 'filter.p.product_type') {
          details.classList.add('beyond-category-filter');
          summary.querySelectorAll('span').forEach(span => {
            [...span.childNodes].filter(n=>n.nodeType===Node.TEXT_NODE && n.textContent.trim()==='Product type').forEach(n=>n.textContent='Category');
          });
          const legend=details.querySelector('legend'); if(legend) legend.textContent='Category';
        }
        if (param === 'filter.p.vendor') {
          summary.querySelectorAll('span').forEach(span=>{if(span.textContent.trim()==='Vendor')span.textContent='Brand';});
          if (inputs.length > 10) {
            details.classList.add('beyond-searchable-brand');
            let search = details.querySelector('[data-brand-search]');
            if (!search) {
              search = document.createElement('input');
              search.type='search'; search.dataset.brandSearch=''; search.placeholder='Find a brand'; search.setAttribute('aria-label','Find a brand');
              const list=details.querySelector('ul'); list?.before(search);
              search.addEventListener('input',event=>{
                event.stopImmediatePropagation();
                brandSearch.set(form.id,search.value);
                const term=search.value.trim().toLowerCase();
                const inputs=[...details.querySelectorAll('input[type="checkbox"][name]')];
                inputs.forEach(input=>input.closest('li').classList.toggle('beyond-search-hidden',!textOf(input).toLowerCase().includes(term)));
                let empty=details.querySelector('.beyond-brand-empty');
                if(!empty){empty=document.createElement('p');empty.className='beyond-brand-empty';empty.setAttribute('role','status');search.after(empty);}
                empty.textContent=inputs.some(i=>!i.closest('li').classList.contains('beyond-search-hidden'))?'':'No brands match.';
              });
            }
            search.value=brandSearch.get(form.id)||'';
            const term=search.value.trim().toLowerCase();
            inputs.forEach(input=>input.closest('li').classList.toggle('beyond-search-hidden',!textOf(input).toLowerCase().includes(term)));
          }
        }
        if (details.classList.contains('colour-filter')) {
          details.classList.add('beyond-colour-filter');
          inputs.forEach(input=>{
            const label=details.querySelector('label[for="'+CSS.escape(input.id)+'"]');
            if(!label)return;
            const name=textOf(input);
            input.setAttribute('aria-label',name); label.title=name;
            if(input.classList.contains('swatch-input__input') && !label.querySelector('.beyond-colour-name')){
              const span=document.createElement('span');span.className='beyond-colour-name';span.textContent=name;label.append(span);
            }
          });
        }
        summary.querySelector('.beyond-filter-selection')?.remove();
        const checked=inputs.filter(i=>i.checked);
        if(checked.length){
          const selected=document.createElement('span');selected.className='beyond-filter-selection';
          selected.textContent=checked.slice(0,2).map(textOf).join(', ')+(checked.length>2?' +'+(checked.length-2):'');
          summary.append(selected);
        }
        details.querySelectorAll('price-range .field__label').forEach((label,i)=>label.textContent=i?'Maximum':'Minimum');
      });
    });
    const quick = document.querySelector('[data-beyond-size]');
    const selected = quick?.selectedOptions[0];
    const clothingSizes = JSON.parse(quick?.dataset.clothingSelection || '[]');
    const sizeLabels = JSON.parse(quick?.dataset.sizeSelectionLabels || JSON.stringify(clothingSizes));
    if (clothingSizes.length || (selected?.dataset.sizeValues && JSON.parse(selected.dataset.sizeValues).length > 1)) {
      document.querySelectorAll('.active-facets-mobile,.active-facets-desktop').forEach(container => {
        const chips = [...container.querySelectorAll('facet-remove')].filter(c=>c.classList.contains('size-remove') || /^Size:/.test(c.textContent.trim()));
        chips.forEach((chip,index)=>{
          chip.classList.toggle('beyond-hidden-filter',index>0);
          if(index)return;
          const a=chip.querySelector('a'),inner=a?.querySelector('.active-facets__button-inner');
          if(!a||!inner)return;
          const url=new URL(a.href,location.origin);url.searchParams.delete(quick.dataset.sizeParam);url.searchParams.delete("b_truck_deck");url.searchParams.delete("b_clothing_sizes");url.searchParams.delete("b_footwear_sizes");a.href=url.pathname+url.search;
          [...inner.childNodes].filter(n=>n.nodeType===Node.TEXT_NODE).forEach(n=>n.remove());
          inner.prepend(document.createTextNode(clothingSizes.length ? 'Size: '+sizeLabels.join(', ')+' ' : (selected.dataset.sizeGroup||'Size')+': '+selected.textContent+' '));
        });
      });
    }
    // Keep the native filter values for Shopify, but expose one useful sale-removal control.
    document.querySelectorAll('.active-facets-mobile,.active-facets-desktop').forEach(container=>{
      const chips=[...container.querySelectorAll('facet-remove')].filter(chip=>chip.classList.contains('percent-discount-range-remove') || /Percent Discount Range/.test(chip.textContent));
      chips.forEach((chip,index)=>{
        chip.classList.toggle('beyond-hidden-filter',index>0);
        if(index)return;
        const link=chip.querySelector('a');if(!link)return;
        const url=new URL(link.href,location.origin);url.searchParams.delete(SALE);link.href=url.pathname+url.search;
        const inner=link.querySelector('.active-facets__button-inner');
        if(inner){[...inner.childNodes].filter(n=>n.nodeType===Node.TEXT_NODE).forEach(n=>n.remove());inner.prepend(document.createTextNode('On sale '));}
        link.setAttribute('aria-label','Remove On sale filter');
      });
    });
    refreshMobileFeedback();
  };
  window.beyondRefreshFilters();
})();
